<template>
  <transition name="router-fade"
              mode="out-in">
    <div class="app-content">
      <router-view></router-view>
      <div class="loading"
           v-if="loading">
        <a-icon width="64px"
                type="loading" />
      </div>
    </div>
  </transition>
</template>

<style lang='scss'>
@import "./styles/main.scss";
</style>	

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'app',
  components: {

  },
  computed: {
    ...mapGetters({
      loading: "getLoading",
    })
  },
  mounted () {
    this.updateLoading(false)
  },
  methods: {
    ...mapActions(['updateLoading']),
  }
}
</script>

<style lang="scss">
.section-content-warp {
  margin: 24px 16px;
  padding: 24px;
  background: #fff;
  min-height: 90vh;
}
.ant-modal-body::-webkit-scrollbar {
  display: none !important;
}

th.column-number,
td.column-number {
  text-align: center !important;
}
#app {
  font-family: "思源黑体", "微软雅黑", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  margin-top: 60px;
}
h1,
h3,
h4,
h5,
h6 {
  font-weight: 400 !important;
}
h2 {
  font-size: 20px;
  color: #555 !important;
}
.ant-layout-content {
  h2 {
    margin-bottom: 24px;
  }
}
.ant-layout-content::-webkit-scrollbar {
  // display: none;
}
ul {
  list-style: none;
}
.dialog-line-div {
  line-height: 60px;
}
.dialog-line-span {
  display: inline-block;
  width: 100px;
  text-align: right;
}
.dialog-line-span strong {
  color: #ff0000;
  font-weight: normal;
}
.ql-editor {
  height: 400px !important;
}
.ant-layout-content {
  overflow: scroll;
}
.ant-modal-body {
  max-height: 600px;
  overflow: scroll;
}
.ant-form-explain {
  padding-left: 80px;
}
.app-content {
  position: relative;
  height: 100%;
}
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  .anticon {
    font-size: 48px;
  }
}
.table-content {
  width: 100%;
  min-height: 100px;
  position: relative;
}
.line {
  margin: 10px 0;
}

.ql-editor {
  height: 100% !important;
}
</style>
